import { put, call } from "redux-saga/effects";

import { BFFAgent } from '../../../../common/BFFAgent';
import {
    GESTION_OPERATIVA_DELETE_BILLS_FAILURE,
    GESTION_OPERATIVA_DELETE_BILLS_SUCCESS
} from '../constants';


export function* deleteBillsSaga(id) {
    try {

        const res = yield call(BFFAgent.Sales.deleteBills, id.data)

        if(res) {
            yield put({
                type: GESTION_OPERATIVA_DELETE_BILLS_SUCCESS,
                data: res
            })
        }

    } catch (err) {
        yield put({
            type: GESTION_OPERATIVA_DELETE_BILLS_FAILURE,
            data: { error: err },
        })
    }

}



